import { result } from "lodash";
import App from "../../../vendor_core/core/src/App";
import { ConfigurationTypes } from "../../../vendor_core/core/src/const/ConfigurationTypes";
import ConfigManager from "../../../vendor_core/core/src/managers/ConfigManager";
import BetModel from "../../../vendor_core/core/src/model/BetModel";
import BuyFeatureModel from "../../../vendor_core/core/src/model/BuyFeatureModel";
import GameModel from "../../../vendor_core/core/src/model/GameModel";
import SpinModel from "../../../vendor_core/core/src/model/SpinModel";
import { State } from "../../../vendor_core/core/src/states/State";
import VendorModel from "../../../vendor_core/src/model/VendorModel";
import FConnector from "../../../vendor_core/src/server/FConnector";
import AbstractVendorLocalConfig from "../../../vendor_core/src/vendorConfigs/AbstractVendorLocalConfig";
import Configs from "../../../vendor_core/src/vendorConfigs/Configs";
import ILocalConfig from "../../../vendor_core/core/src/managers/contracts/configurations/ILocalConfig";
import IFeatureRTP from "../server/interface/IFeatureRTP";
import CommandManager from "../../../vendor_core/core/src/commands/CommandManager";
import { Commands } from "../../../vendor_core/core/src/commands/CommandEnum";
import DoubleChanceModel from "../../model/DoubleChanceModel";

export default class TRWAuthorizationState extends State {
    protected sessionData: any;
    public async enter() {
        super.enter();

        await FConnector.initialize();
		FConnector.initRealityCheck(
			() => {
                CommandManager.execute(Commands.STOP_AUTOPLAY);
			},
			() => {},
			() => {
				FConnector.openHistory();
			},
		);

        // Recover partial spin
        if (GameModel.urlParams.roundId) {
            let replay = await FConnector.replay(GameModel.urlParams.roundId);

            Configs.game.parseRTP((replay as any).config.rtps.rtp);
            ConfigManager.getConfig(ConfigurationTypes.LOCAL)
            //@ts-ignore
                .parseBonusRTPs(
                    (replay as any).config?.rtps.buyFeature,
                    (replay as any).config?.rtps.scatterBoost
                );

            VendorModel.nextAction = "skip_complete";
            replay.bets.main.default = replay.round?.wagers[0].bet as number;
            // dirty hack, when viewing a replay with activated double chance
            replay.bets.main.default = (<any>replay.round?.wagers[0]?.data)?.betMode === 1 ? replay.bets.main.default / 1.25 : replay.bets.main.default;
            let config = {
                balance: replay.round.wagers[0].win ? replay.balanceAfter - (replay.round.wagers[0].win as number) : replay.round.wagers[0].win as number,
                bets: replay.bets,
                config: replay.config,
                settings: replay.settings,
                currency: replay.currency,
                state: replay.state
            }
            //@ts-ignore
            config.config.reelgrids.forEach((reelSet) =>{
                App.config.reelSets.push(reelSet.reels)
            })
            GameModel.update({ ...config });
            VendorModel.update({ ...replay });
            VendorModel.update(replay.round);
            GameModel.replayBalanceAfterWin = replay.balanceAfter;
            GameModel.restoreData = replay.round.wagers;
            if (replay?.round.wagers?.length > 0) {
                SpinModel.update({
                    wager: replay.round.wagers[0]
                })
            }

            BetModel.update({ ...config });
            BetModel.setInitialParams();
            GameModel.isReplay = true;
            Configs.buyFeature.parseConfig((<any>replay).config.costs)
            Configs.buyFeature.parseConfig((<any>replay).bets);

            DoubleChanceModel.mode = (<any>replay.round?.wagers[0]?.data)?.betMode;
        } else {
            const authInfo = await FConnector.authenticate();
            const config = await FConnector.info();
            
            Configs.game.parseRTP((config as any).config.rtps.rtp);
            ConfigManager.getConfig(ConfigurationTypes.LOCAL)
            //@ts-ignore
                .parseBonusRTPs(
                    (config as any).config?.rtps.buyFeature,
                    (config as any).config?.rtps.scatterBoost
                );

            config.config.reelgrids.forEach((reelSet) =>{
                App.config.reelSets.push(reelSet.reels)
            })
            await FConnector.unmuted();
            GameModel.update({ ...authInfo, ...config });
            VendorModel.update({...config });
            const restoreData = await FConnector.recover();

            GameModel.restoreData = restoreData.wagers || null;
            VendorModel.update(restoreData);

            if (restoreData?.wagers?.length > 0) {
                SpinModel.update({
                    wager: restoreData.wagers[0]
                })
            }
            //@ts-ignore
            BetModel.lastBet = restoreData.wagers?.[0]?.data?.bet
            BetModel.update({ ...authInfo, ...config });
            BetModel.setInitialParams();
            Configs.buyFeature.parseConfig((<any>config).config.costs);
            Configs.buyFeature.parseConfig((<any>config).bets);
        }
        BuyFeatureModel.update();
        BetModel.betDivisor = 20;

        VendorModel.setupJurisdictionSettings();

        this.exit();
    }
}
